import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { PLANS_STATUS } from '../../constants/subscription';

import LoadingBar from '../../components/LoadingBar';

import Error403 from '../Error403';

const ComponentProvider = ({ children, features }) => {
  const subscriptionState = useSelector(state => state.subscription);
  const userState = useSelector(state => state.user);

  const isAccessible = useMemo(() => {
    const isAdmin = userState.isAdmin;
    const hasDefaultFeature = features.includes('default');
    const hasActivePlan = subscriptionState.myPlan.status === PLANS_STATUS.ACTIVE;
    const hasMappedFeature = features.some(f => subscriptionState.myMappedFeatureOptions?.[f]);
    const hasInvitations = userState.user.activeInvitations?.length > 0;

    return isAdmin || hasDefaultFeature || (hasMappedFeature && hasActivePlan) || hasInvitations;
  }, [features, subscriptionState, userState]);

  if (subscriptionState.loading || userState.loading || !userState.user?.id) {
    return <LoadingBar fullscreen={true} />;
  }

  return isAccessible ? <div className="component-provider">{children}</div> : <Error403 />;
};

export default ComponentProvider;
